<ol class="ps-breadcrumb">
  <li class="ps-breadcrumb-item">{{root}}</li>
  <li class="ps-breadcrumb-item" *ngFor="let item of data">
    {{item.title}}
  </li>
</ol>
